import React, { useState, useEffect } from 'react';
import { AiFillAlert } from "react-icons/ai";
import { GrShieldSecurity } from "react-icons/gr";
import { LiaToggleOffSolid } from "react-icons/lia";
import { FaChevronCircleDown } from "react-icons/fa";
import BottomNav from '../../components/BottomNav/Boomnav';
import './SettingsPage.css';

const planos = [
  { id: 'pro', nome: 'Prisma Pro', descricao: 'Acesso essencial', valor: 56.24, recomendado: false, bonus: 1094.00, beneficios: ['Acesso à IA Prisma', 'Alocação automática', 'Garantia de Blindagem'] },
  { id: 'master', nome: 'Prisma Master', descricao: 'Aceleração total', valor: 112.89, recomendado: true, bonus: 2196.00, beneficios: ['Tudo do PRO', 'Assessoria Premium', 'Baixo Risco Ativado'] },
  { id: 'prime', nome: 'Prisma Prime', descricao: 'Gestão VIP', valor: 168.31, recomendado: false, bonus: 3274.00, beneficios: ['Tudo do MASTER', 'Suporte 24/7 VIP', 'Setup Mãos Livres'] },
];
const potencialBonus = 3274.00;

const SettingsPage = ({ onNavigate }) => {
  const handleAtivarAcesso = () => {
    let url = '';
    switch (planoSelecionado) {
      case 'pro':
        url = 'https://payfast.greenn.com.br/133077/offer/LpyWgN?src=app';
        break;
      case 'master':
        url = 'https://payfast.greenn.com.br/133077/offer/DVvwVK?src=app';
        break;
      case 'prime':
        url = 'https://payfast.greenn.com.br/133077/offer/PjhVeb?src=app';
        break;
      default:
        url = 'https://prisma-ia.com/ativar';
    }
    window.open(url, '_blank');
  };
  const [active, setActive] = useState('settings');
  const [planoSelecionado, setPlanoSelecionado] = useState('master');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [moeda] = useState('USD (Dólar Americano)');
  const [notificacoes, setNotificacoes] = useState({ oportunidades: true, relatorios: true, alertas: true });
  const [autenticacao2fa, setAutenticacao2fa] = useState(false);
  const [toast, setToast] = useState(false);

  useEffect(() => {
    const usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'));
    if (usuarioLogado) {
      setNome(usuarioLogado.name || '');
      setEmail(usuarioLogado.email || '');
    }
  }, []);

  const handleNavChange = (id) => {
    setActive(id);
    if (onNavigate) onNavigate(id);
  };
  const plano = planos.find(p => p.id === planoSelecionado);

  const showToast = () => {
    setToast(true);
    setTimeout(() => setToast(false), 2200);
  };

  return (
    <div className="settings-page" style={{ paddingBottom: 90, height: '100vh', overflowY: 'auto', background: '#1A1D24' }}>
      <div style={{ maxWidth: 420, margin: '0 auto', padding: '0 16px 16px 16px', minHeight: '100vh', boxSizing: 'border-box', position: 'relative', marginTop: -85 }}>
        {toast && (
          <div style={{
            position: 'fixed',
            top: 50,
            left: 0,
            right: 0,
            margin: '0 auto',
            zIndex: 9999,
            background: '#232b36',
            color: '#fff',
            fontWeight: 700,
            fontSize: 15,
            borderRadius: 10,
            padding: '14px 32px',
            width: 'fit-content',
            boxShadow: '0 2px 16px 0 #0002',
            textAlign: 'center',
            letterSpacing: 0.5,
            opacity: toast ? 1 : 0,
            transition: 'opacity 0.3s',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}>
            <AiFillAlert style={{ marginRight: 8, color: '#ff0000', fontSize: 22 }} />
            recurso indisponivel na demonstração
          </div>
        )}
        <h1 style={{ fontSize: 20, fontWeight: 800, color: '#ffffff', marginBottom: 6 }}>Configurações</h1>
        {/* Ambiente Seguro */}
        <div style={{ background: '#47526B', borderRadius: 16, border: '1.5px solid #00c689', marginBottom: 18, padding: 18, display: 'flex', alignItems: 'flex-start', gap: 12 }}>
          <span style={{ fontSize: 28, color: '#00c689', marginTop: 2, display: 'flex', alignItems: 'center' }}><GrShieldSecurity size={28} color="#00c689" /></span>
          <div>
            <div style={{ fontWeight: 700, color: '#00c689', fontSize: 17, marginBottom: 2 }}>Ambiente Seguro</div>
            <div style={{ color: '#f5f5f5', fontSize: 14 }}>Para sua segurança, recomendamos manter seus dados de acesso sempre atualizados.</div>
          </div>
        </div>
        {/* Planos & Assinatura */}
        <div style={{ background: '#47526B', borderRadius: 16, border: '1.5px solid #00c689', marginBottom: 18, padding: 0 }}>
          <div style={{ borderBottom: '1.5px solid #00c689', padding: 18, fontWeight: 700, fontSize: 18, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: '#00C689' }}>Planos & Assinatura</span>
            <span style={{ color: '#00c689', fontSize: 18, fontWeight: 900 }}>▼</span>
          </div>
          <div style={{ padding: 18, borderBottom: '1.5px solid #E2E8F0', background: '#E0F2FE', color: '#0369A1', fontSize: 11, borderRadius: 8, margin: 12, marginBottom: 0 }}>
            <strong>Protocolo: Saldo em Dobro.</strong> Potencial de bônus: R$ {potencialBonus.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}.
          </div>
          <div style={{ padding: 18, paddingBottom: 0 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {planos.map(p => (
                <div
                  key={p.id}
                  onClick={() => setPlanoSelecionado(p.id)}
                  style={{
                    border: planoSelecionado === p.id ? '2px solid #00C689' : '1.5px solid #E2E8F0',
                    borderRadius: 16,
                    padding: 14,
                    background: '#fff',
                    position: 'relative',
                    cursor: 'pointer',
                    boxShadow: planoSelecionado === p.id ? '0 0 0 2px #00c68933' : 'none',
                    outline: planoSelecionado === p.id ? '2px solid #00c689' : 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: 54,
                  }}
                >
                  {p.recomendado && (
                    <div style={{ position: 'absolute', top: -8, right: 10, background: '#00C689', color: '#fff', fontWeight: 800, fontSize: 10, borderRadius: 8, padding: '2px 8px', letterSpacing: 1 }}>RECOMENDADO</div>
                  )}
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#232b36' }}>{p.nome}</div>
                    <div style={{ fontSize: 10, color: '#64748B', marginTop: 2 }}>{p.descricao}</div>
                  </div>
                  <div className="text-mono" style={{ fontSize: 13, fontWeight: 700, color: '#000000', marginLeft: 16, whiteSpace: 'nowrap' }}>12x R$ {p.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                </div>
              ))}
            </div>
            {/* Detalhes do plano selecionado */}
            <div style={{ marginTop: 18 }}>
              <div className="text-mono" style={{ fontSize: 20, fontWeight: 800, color: '#ffffff', marginBottom: 8, lineHeight: 1 }}>12x R$ {plano.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
              <div style={{ background: '#e6fff4', border: '2px dashed #00c689', borderRadius: 8, padding: '10px 14px', fontWeight: 700, color: '#00c689', fontSize: 15, margin: 0, whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
                BÔNUS + GARANTIA:&nbsp;<span style={{ fontWeight: 900 }}>R$ {plano.bonus.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
              </div>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, marginBottom: 18 }}>
                {plano.beneficios.map((beneficio, idx) => (
                  <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#ffffff', fontWeight: 700, fontSize: 16, marginBottom: 6 }}>
                    <FaChevronCircleDown style={{ fontSize: 20, color: '#00c689' }} /> {beneficio}
                  </li>
                ))}
              </ul>

              <button
                style={{ width: '100%', background: '#00c689', color: '#fff', fontWeight: 800, fontSize: 20, border: 'none', borderRadius: 12, padding: 18, marginTop: 9, marginBottom: 19, cursor: 'pointer', letterSpacing: 1 }}
                onClick={handleAtivarAcesso}
              >
                ATIVAR ACESSO
              </button>
            </div>
          </div>
        </div>
        {/* Perfil do Usuário */}
        <div className="card" style={{ background: '#47526B', borderRadius: 16, border: '1.5px solid #00C689', marginBottom: 18, padding: 18 }}>
          <div className="card-header" style={{ fontWeight: 700, fontSize: 17, marginBottom: 12, color: '#00C689' }}>Perfil do Usuário</div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 11, color: '#c0d0e6', fontWeight: 600 }}>NOME COMPLETO</label>
            <input type="text" className="input-box" value={nome} readOnly style={{ height: 44, marginTop: 4, width: '100%', borderRadius: 8, border: '1.5px solid #E2E8F0', padding: 10, fontSize: 15, background: '#f8fafc' }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 11, color: '#c0d0e6', fontWeight: 600 }}>E-MAIL DE ACESSO</label>
            <input type="email" className="input-box" value={email} readOnly style={{ height: 44, marginTop: 4, width: '100%', borderRadius: 8, border: '1.5px solid #E2E8F0', padding: 10, fontSize: 15, background: '#f8fafc' }} />
          </div>
          <div>
            <label style={{ fontSize: 11, color: '#c0d0e6', fontWeight: 600 }}>MOEDA PADRÃO</label>
            <input type="text" className="input-box" value={moeda} readOnly style={{ height: 44, marginTop: 4, width: '100%', borderRadius: 8, border: '1.5px solid #E2E8F0', padding: 10, fontSize: 15, background: '#f8fafc', color: '#64748B' }} />
          </div>
        </div>
        {/* Segurança & Acesso */}
        <div className="card" style={{ background: '#47526B', borderRadius: 16, border: '1.5px solid #00C689', marginBottom: 18, padding: 18 }}>
          <div className="card-header" style={{ fontWeight: 700, fontSize: 17, marginBottom: 12, color: '#00C689' }}>Segurança & Acesso</div>
          <div className="settings-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #E2E8F0', cursor: 'pointer' }} onClick={showToast}>
            <div>
              <span className="settings-label" style={{ fontWeight: 700, color: '#fff', marginRight: 49 }}>Alterar Senha</span><br />
              <span className="settings-desc" style={{ color: '#a4c3ee', fontSize: 13 }}>Última alteração há 3 dias</span>
            </div>
            <span style={{ color: '#a4c3ee', fontSize: 18 }}>›</span>
          </div>
          <div className="settings-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', }}>
            <div>
              <span className="settings-label" style={{ fontWeight: 700, color: '#fff', marginRight: 49 }}>Autenticação 2FA</span><br />
              <span className="settings-desc" style={{ color: '#a4c3ee', fontSize: 13 }}>Maior proteção para sua conta</span>
            </div>
            <span style={{ cursor: 'pointer' }} onClick={showToast}>
              <LiaToggleOffSolid size={32} color="#0a0a0a" />
            </span>
          </div>

        </div>
        {/* Notificações */}
        <div className="card" style={{ background: '#47526B', borderRadius: 16, border: '1.5px solid #00C689', marginBottom: 18, padding: 18 }}>
          <div className="card-header" style={{ fontWeight: 700, fontSize: 17, marginBottom: 12, color: '#00C689' }}>Notificações</div>
          <div className="settings-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #E2E8F0' }}>
            <span className="settings-label" style={{ fontWeight: 700, color: '#fff' }}>Oportunidades Detectadas</span>
            <span style={{ cursor: 'pointer' }} onClick={showToast}>
              <LiaToggleOffSolid size={32} color="#000000" />
            </span>
          </div>
          <div className="settings-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #E2E8F0' }}>
            <span className="settings-label" style={{ fontWeight: 700, color: '#fff' }}>Relatórios de Fechamento</span>
            <span style={{ cursor: 'pointer' }} onClick={showToast}>
              <LiaToggleOffSolid size={32} color="#000000" />
            </span>
          </div>
          <div className="settings-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0' }}>
            <span className="settings-label" style={{ fontWeight: 700, color: '#fff' }}>Alertas de Segurança</span>
            <span style={{ cursor: 'pointer' }} onClick={showToast}>
              <LiaToggleOffSolid size={32} color="#000000" />
            </span>
          </div>
        </div>
        {/* Links e ações finais */}
        <div style={{ margin: '20px 0', textAlign: 'center' }}>
          <button type="button" className="btn btn-primary" style={{ height: 48, fontSize: 20, fontWeight: 600, borderRadius: 8, background: '#00c689', color: '#fff', border: 'none', width: '100%', margin: '4px 0' }}>SALVAR ALTERAÇÕES</button>
          <button type="button" className="btn btn-primary" style={{ height: 48, fontSize: 20, fontWeight: 600, borderRadius: 8, background: '#ef4444', color: '#fff', border: 'none', width: '100%', margin: '12px 0 4px 0' }} onClick={() => { if (onNavigate) onNavigate('login'); }}>Encerrar Sessão</button>
        </div>
      </div>
      <BottomNav active={active} onChange={handleNavChange} />
    </div>
  );
};

export default SettingsPage;
